import { cn } from "@/utils/cn"

type SpinnerProps = React.ComponentProps<"svg"> & {
  size?: number | string
}

function Spinner({ className, size = 16, ...props }: SpinnerProps) {
  return (
    <div className={cn("flex items-center justify-center [&_iconpark-icon]:animate-spin", className)}>
      <iconpark-icon
        name="outline-loader-circle"
        role="status"
        aria-label="Loading"
        size={size}
        {...props}
      />
    </div>
  )
}

export { Spinner }
